import {
  AnimationTriggerMetadata,
  animate,
  animateChild,
  group,
  query,
  sequence,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const dialogAnimations: {
  readonly dialogState: AnimationTriggerMetadata;
} = {
  dialogState: trigger('state', [
    state('void, hidden', style({ transform: 'translateY(20%)' })),
    state('visible', style({ transform: 'translateY(0%)', opacity: 1 })),
    transition(
      'void => visible, hidden => visible',
      group([
        sequence([
          style({
            transform: `translateY(30px)`,
            opacity: 0,
          }),
          animate('250ms cubic-bezier(0, 0, 0.2, 1)'),
        ]),
        query('@*', animateChild(), { optional: true }),
      ])
    ),
    transition(
      'visible => void, visible => hidden',
      group([
        sequence([
          style({
            transform: `translateY(0)`,
            opacity: 1,
          }),
          animate(
            '75ms cubic-bezier(0.4, 0.0, 0.2, 1)',
            style({
              opacity: 0,
            })
          ),
        ]),
        query('@*', animateChild(), { optional: true }),
      ])
    ),
  ]),
};
